import { Action, createReducer, on } from '@ngrx/store';
import * as categoriesActions from './categories-actions';
import * as fromCategories from './categories-state';
import {CategoryPagedResponse} from '@app/marketplace/categories/_models/category.interface';

const initialState: fromCategories.State = {isLoading: false, data: {count: 0, totalCount: 0} as CategoryPagedResponse, categoryCode: '', categoryName: ''};
export const reducer = createReducer(
  initialState,
  on(categoriesActions.ListCategories, (state) => {
    return {...state, isLoading: true};
  }),
  /* on(categoriesActions.LoadCategoryCodeActions, (state, {categoryCode }) => {
     return {... state, categoryCode };
   }), */
  on(categoriesActions.CancelRequestCategories, (state) => {
    return {...state, isLoading: false};
  }),
   on(categoriesActions.ListCategoriesSuccess, (state, {data}) => {
    return {...state, isLoading: false, data};
  }),
  on(categoriesActions.ListCategoriesFailure, (state) => {
    return {...state, isLoading: false};
  }),
  on(categoriesActions.ListProductsByCategory, (state, {code, name}) => {
    return {...state, categoryCode: code, categoryName: name};
  }),
  on(categoriesActions.ClearCategoryFilter, (state) => {
    return {...state,categoryCode:"",categoryName:""};
  })
);

